import { toPairs, map, merge } from 'ramda';
import ordersListTpl from './ordersList.tpl.html';
import { getOrders, getLoading } from '../../reducers/orders';
import utils from '../../services/utils';

export class OrdersList {
  constructor($scope, $ngRedux, actionsFactory, usersService, companiesService, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      $translate,
      actionsFactory,
      usersService,
      companiesService,
      validateEmail: OrdersList.validateEmail,
      ordersTypes: {
        pending: 'pending',
        edited: 'edited',
        archived: 'archived',
      },
      search: {
        pending: {},
        edited: {},
        archived: {},
      },
      pagination: {
        pending: { page: 1, limit: '10' },
        edited: { page: 1, limit: '10' },
        archived: { page: 1, limit: '10' },
      },
      message: null,
    });

    this.unsubscribeRedux = $ngRedux.connect(OrdersList.mapStateToThis, actionsFactory)(this);
    this.usubscribeScopeListener = $scope.$on('order-marked-completed', () => {
      this.reqOrders('pending', this.pagination.pending);
      this.reqOrders('edited', this.pagination.edited);
      this.reqOrders('archived', this.pagination.archived);
    });
    this.usubscribeScopeListener = $scope.$on('order-marked-reopened', () => {
      this.reqOrders('pending', this.pagination.pending);
      this.reqOrders('edited', this.pagination.edited);
      this.reqOrders('archived', this.pagination.archived);
    });
    this.canAddBaseAccount = OrdersList.canAddBaseAccount;
    this.getProductLabelName = OrdersList.getProductLabelName;
  }

  $onInit() {
    this.reqEnumList('statuses.orders');
    this.reqEnumList('statuses.bi');
    this.reqEnumList('statuses.questionnaire');
    this.reqOrders('pending', this.pagination.pending);
    this.reqOrders('edited', this.pagination.edited);
    this.reqOrders('archived', this.pagination.archived);
    this.showConfirmationModal = false;
    this.editingData = {};
    this.isBuyerOrMasterOrDirector = utils.isLoggedInUserOfType(this.me.type, ['buyer',
      'master',
      'director']);
    this.isEditorOrMasterOrDirector = utils.isLoggedInUserOfType(this.me.type, ['editor',
      'master',
      'director']);
    this.isEditorOrBase = utils.isLoggedInUserOfType(this.me.type, ['editor', 'base']);
    this.isEditor = utils.isLoggedInUserOfType(this.me.type, ['editor']);
    this.showCompleteOrderModal = false;
    this.orderToBeCompleted = null;
    this.orderToBeReopened = null;
    this.newUser = {};
    this.showModal = false;
    this.orderCompany = {};
    this.investigationOrderId = null;
    this.investigationCompanyName = null;
    this.investigation = {};
    this.showInvestigationCodesModal = false;
    this.panesOpened = [];
  }

  $onDestroy() {
    this.unsubscribeRedux();
    this.usubscribeScopeListener();
  }

  getPageCount(type) {
    if (this.orders[type].total) {
      let numPages = Math.floor(
        this.orders[type].total / parseInt(this.pagination[type].limit, 10));

      if (this.orders[type].total % this.pagination[type].limit) {
        numPages += 1;
      }

      return numPages;
    }

    return 1;
  }

  static getProductLabelName(productType) {
    const productTypeLabel = productType.replace('_NEW', '').replace('_EXISTING', '');
    return productTypeLabel;
  }

  completeOrder(order) {
    this.orderToBeCompleted = order;
    this.showCompleteOrderModal = true;
  }

  reopenOrder(order) {
    this.orderToBeReopened = order;
    this.showReopenOrderModal = true;
  }

  confirmCompleteOrder() {
    this.completeOrderStart(this.orderToBeCompleted.id, this.message);
    this.closeCompleteOrderModal();
  }

  confirmReopenOrder() {
    this.reopenOrderStart(this.orderToBeReopened.id, this.message);
    this.closeReopenOrderModal();
  }

  getOrderModalDescriptionGeneral() {
    return this.$translate.instant('COMPLETE_ORDER_MODAL_DESCRIPTION_GENERAL', {
      buyerName: this.orderToBeCompleted.buyer.fullName,
      companyName: this.orderToBeCompleted.company.name,
    });
  }

  getOrderModalDescriptionReopen() {
    return this.$translate.instant('REOPEN_ORDER_MODAL_DESCRIPTION_GENERAL', {
      buyerName: this.orderToBeReopened.buyer.fullName,
      companyName: this.orderToBeReopened.company.name,
    });
  }

  getOrderModalDescriptionAttachMessage() {
    return this.$translate.instant('COMPLETE_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE', {
      buyerName: this.orderToBeCompleted.buyer.fullName,
    });
  }

  getOrderModalDescriptionAttachMessageReopen() {
    return this.$translate.instant('REOPEN_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE', {
      buyerName: this.orderToBeReopened.buyer.fullName,
    });
  }

  closeCompleteOrderModal() {
    this.showCompleteOrderModal = false;
    this.orderToBeCompleted = null;
    this.message = null;
  }

  closeReopenOrderModal() {
    this.showReopenOrderModal = false;
    this.orderToBeReopened = null;
    this.message = null;
  }

  isLoggedInUserOfType(types) {
    return utils.isLoggedInUserOfType(this.me.type, types);
  }

  static mapStateToThis(state) {
    return {
      orders: {
        pending: {
          items: getOrders(state, 'pending'),
          loading: getLoading(state, 'pending'),
          total: state.orders.pending.total,
        },
        edited: {
          items: getOrders(state, 'edited'),
          loading: getLoading(state, 'edited'),
          total: state.orders.edited.total,
        },
        archived: {
          items: getOrders(state, 'archived'),
          loading: getLoading(state, 'archived'),
          total: state.orders.archived.total,
        },
      },
      enums: state.enums,
      me: state.authentication.user,
    };
  }

  openConfirmationModal(orderId, questionnaireId, userId) {
    this.showConfirmationModal = true;
    this.editingData = {
      orderId,
      questionnaireId,
      userId,
    };
  }

  assignUser() {
    this.assignContactUser(this.editingData.questionnaireId, this.editingData.userId);
    this.hideConfirmationModal();
  }

  hideConfirmationModal() {
    this.editingData = {};
    this.showConfirmationModal = false;
  }

  changePageLimit(type) {
    this.pagination[type].page = 1;
    const params = merge(this.search[type], this.pagination[type]);
    this.reqOrders(type, params);
  }

  searchOrders(type) {
    this.pagination[type].page = 1;
    const params = merge(this.search[type], this.pagination[type]);
    this.reqOrders(type, params);
  }

  goTo(state, params) {
    this.state(state, params);
  }

  mapStatuses(statuses) {
    const statusPairs = toPairs(statuses.statuses);
    this.statusPairs = statusPairs;

    const yellowStatuses = map(element => element[0],
      statusPairs.slice(1, statusPairs.length - 1));

    return {
      red: statusPairs.length > 0 ? [statusPairs[0][0]] : [],
      yellow: statusPairs.length > 1 ? yellowStatuses : [],
      green: statusPairs.length > 0 ? [statusPairs[statusPairs.length - 1][0]] : [],
    };
  }

  prevPage(type) {
    this.pagination[type].page -= 1;
    const params = merge(this.search[type], this.pagination[type]);
    this.reqOrders(type, params);
  }

  nextPage(type) {
    this.pagination[type].page += 1;
    const params = merge(this.search[type], this.pagination[type]);
    this.reqOrders(type, params);
  }

  showAddModal(type, order) {
    this.orderCompany = order.company;
    this.newUser.type = type;
    this.showModalAdd = true;
    this.newUser.companyId = order.company.id;
    this.newUser.firstName = order.contact.firstName;
    this.newUser.lastName = order.contact.lastName;
    this.newUser.email = order.contact.email;
  }

  closeAllModals() {
    this.showModalAdd = false;
    this.newUser = {};
    this.orderCompany = {};
  }

  confirmAddModal() {
    this.addUser(this.newUser);
    this.showAddModal = false;
  }

  handlePaneClick(orderId) {
    if (this.panesOpened.indexOf(orderId) < 0) {
      this.panesOpened.push(orderId);
    }
  }

  getCreateAccountModalTitle(type) {
    const userType = this.getAccountTypeDescription(type);
    return this.$translate.instant('MODAL_TITLE_CREATE_ACCOUNT', {
      userType: userType.toUpperCase(),
    });
  }

  getAccountTypeDescription(type) {
    return this.$translate.instant(`ACCOUNT_TYPE_${type && type.toUpperCase()}`);
  }

  /* eslint-disable */
  onContactUserSelected(item, model, binding) {
    binding.contactUser = item;
  }
  /* eslint-enable */

  doShowInvestigationCodesModal(order) {
    this.investigationOrderId = order.id;
    this.investigationCompanyName = order.company.name;
    this.investigation.code = order.investigation.code;
    this.investigation.subcode = order.investigation.subcode;
    this.showInvestigationCodesModal = true;
  }

  hideInvestigationCodesModal() {
    this.investigation = {};
    this.investigationOrderId = null;
    this.investigationCompanyName = null;
    this.showInvestigationCodesModal = false;
  }

  confirminvestigationCodesModal() {
    this.updateInvestigationCodesStart(
      this.investigationOrderId,
      this.investigation,
    );
    this.showAddModal = false;
  }

  static canAddBaseAccount(order) {
    return order.contact &&
      order.contact.firstName !== null &&
      order.contact.lastName !== null &&
      order.contact.email !== null &&
      order.contact.phone !== null;
  }

  disableAdd() {
    const result = !this.newUser.firstName ||
      !this.newUser.lastName ||
      !this.validateEmail(this.newUser.email) ||
      (!this.newUser.companyId && this.newUser.type !== 'editor' &&
  this.isLoggedInUserOfType(['editor']));
    return result;
  }

  static validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
    return re.test(String(email).toLowerCase());
  }
}

OrdersList.$inject = ['$scope',
  '$ngRedux',
  'actionsFactory',
  'usersService',
  'companiesService',
  '$translate',
];

export const ordersList = {
  template: ordersListTpl,
  controller: OrdersList,
};
